import { render } from "./Confirm.vue?vue&type=template&id=1f6a1956"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
script.render = render

export default script